import { Component, Inject, ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { map } from 'rxjs/operators';

@Component( {
    selector: 'lib-confirm-dialog',
    template: `
        <h2 mat-dialog-title>{{ title }}</h2>
        <div mat-dialog-content>
            {{ message }}
            <div *ngIf="note"><br/>{{ note }}</div>
            <div *ngIf="alert" class="mat-error"><br/>{{ alert }}</div>
        </div>
        <mat-dialog-actions>
            <button mat-button mat-raised-button [color]="buttonColor" [mat-dialog-close]="true">{{ yes }}</button>
            <button mat-button mat-raised-button mat-dialog-close>{{ no }}</button>
        </mat-dialog-actions>
        <mat-checkbox class="doForAll" #doForAll *ngIf="showDoForAll">Do this for all instances.</mat-checkbox>`,
    styles: [
        `.mat-dialog-actions { display: flex; }`,
        `.mat-raised-button { flex-grow: 1; }`,
        `.mat-dialog-content { white-space: pre-line; }`,
        `.doForAll { margin-top: 1em; }`,
    ]
} )
export class ConfirmDialogComponent {

    public title: string;
    public message: string;
    public note: string;
    public alert: string;
    public yes: string;
    public no: string;
    public showDoForAll: boolean;

    public buttonColor: 'primary' | 'accent' | 'warn' | 'success' = 'primary';
    
    @ViewChild( 'doForAll' )
    protected doForAll: MatCheckbox;

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject( MAT_DIALOG_DATA ) public data: any
    ) {
        this.title = data.title ?? 'Confirm';
        this.message = data.msg ?? data.message ?? 'Are you sure you wish to perform this action?';
        this.note  = data.note  ?? null;
        this.alert = data.alert ?? null;
        this.yes   = data.yes   ?? 'Ok';
        this.no    = data.no    ?? 'Cancel';
        this.buttonColor = data.buttonColor ?? 'primary';
        this.showDoForAll = data.showDoForAll ?? false;
    }

    doForAllChecked() {
        return this.doForAll.change.asObservable().pipe( map( ( v ) => v.checked ) );
    }

    
}
